'use client';
import { useCategoryTree } from '@/hooks/category/useCategoryTree';
import useCart from '@/store/cart.store';
import useCheckout from '@/store/checkout.store';
import { mergeGuestCart } from '@/utils/cart/MergeGuestCart';
import { deleteCookie, getCookie } from 'cookies-next';
import { useSession } from 'next-auth/react';
import { useEffect, useRef, useState } from 'react';
// import { addItemsToCartAfterCancelOrder } from '@/utils/cart';
import FailedModal from '@/components/ui/FailedModal';
import { useSessionTimeout } from '@/hooks/useSessionTimeOut';
import { useRouter } from '@/i18n/navigation';
import { signOutHandler } from '@/utils/auth';
import { handleAddToActiveCart } from '@/utils/global';
import { event_payment_failed } from '@/utils/gtm';
import { usePathname, useSearchParams } from 'next/navigation';
// import useShippingInfoStore from '@/store/shipping-info.store';
import useGlobalStore from '@/store/global.store';
import ViewPage from '@/utils/view-page';
import { useLocale, useTranslations } from 'next-intl';
// for any client side code would be global
const GlobalConfig = ({ children, deliveryOptions }) => {
  console.log('GlobalConfig deliveryOptions:', deliveryOptions);
  const { setIsOldUser, setDeliveryOptions } = useGlobalStore();

  useCategoryTree();
  const { data: session } = useSession();
  const pathname = usePathname();
  const { push } = useRouter();
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams);
  const checkout_order_id = getCookie('checkout_order_id');
  // const amount = getCookie('amount');
  // const payment_code = getCookie('payment_code');
  // const number_of_products = getCookie('number_of_products');
  const locale = useLocale();
  //handle session with custom expiration time (remember me)
  useSessionTimeout();

  const t = useTranslations('modals');
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const trackedPaymentFailureRef = useRef(null);

  const trackPaymentFailure = ({ payment_type, reason, transaction_id }) => {
    if (!transaction_id || trackedPaymentFailureRef.current === transaction_id)
      return;
    trackedPaymentFailureRef.current = transaction_id;
    event_payment_failed({
      payment_type: payment_type || getCookie('payment_code'),
      reason,
      transaction_id,
      value: getCookie('amount'),
    });
  };

  // const setUserLatAndLng = useShippingInfoStore(
  //   (state) => state.setUserLatAndLng
  // );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {setDeliveryOptions(deliveryOptions)}, [deliveryOptions]);

  const mage = getCookie('mage');

  useEffect(() => {
    if (session?.user && !mage) {
      signOutHandler(setIsOldUser, session?.user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.user, mage]);

  // merge guest cart to user cart
  useEffect(() => {
    mergeGuestCart(session);
  }, [session]);

  const clearCheckout = useCheckout((state) => state.clearCheckout);
  const setShippingMethods = useCheckout((state) => state.setShippingMethods);
  const { resetCart } = useCart((store) => store);

  useEffect(() => {
    if (
      (query?.success == 'false' || query?.success == false) &&
      query?.order_id
    ) {
      trackPaymentFailure({
        payment_type: query?.payment,
        reason: query?.reason,
        transaction_id: query?.order_id,
      });
      if (query?.reason) {
        setIsFailedModalOpen(true);
      }
      handleAddToActiveCart(query?.order_id, push, locale);
      setTimeout(() => {
        deleteCookie('payment_code');
        deleteCookie('number_of_products');
        deleteCookie('amount');
      }, 3000);
      // const errorMessage = getErrorMessage(
      //   query?.payment,
      //   query?.reason,
      //   locale
      // );
      // toast.error(errorMessage, { position: 'top-center' }); // Required by Tabby
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    push,
    query?.order_id,
    query?.success,
    locale,
    query?.payment,
    query?.reason,
  ]);

  useEffect(() => {
    pathname !== '/checkout' && setShippingMethods([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (getCookie('orderStatus') == 'placed') {
      deleteCookie('orderStatus');
      resetCart();
      clearCheckout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Check if he return back from payment with out completing order
  useEffect(() => {
    const path = pathname?.replace(/^\/en(?=\/|$)/, '');
    if (
      (path === '/checkout' ||
        path === '/cart' ||
        ((query?.success == 'false' || query?.success == false) &&
          query?.order_id)) &&
      !!checkout_order_id
    ) {
      trackPaymentFailure({
        reason: query?.reason || 'Payment not completed',
        transaction_id: checkout_order_id,
      });
      setIsFailedModalOpen(true);
      handleAddToActiveCart(checkout_order_id, push, mage);
      deleteCookie('payment_code');
      deleteCookie('number_of_products');
      deleteCookie('amount');
      setTimeout(() => {
        deleteCookie('checkout_order_id');
      }, 1500);
    } else if (!!checkout_order_id) {
      deleteCookie('checkout_order_id');
    }
  }, [pathname, query]);

  // useEffect(() => {
  //   if (navigator?.geolocation) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       setUserLatAndLng({
  //         lat: position.coords.latitude,
  //         lng: position.coords.longitude,
  //       });
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // useEffect(() => {
  //   const scrollToTargetPosition = () => {
  //     setTimeout(() => {
  //       if (typeof window !== 'undefined') {
  //         if ('scrollBehavior' in document.documentElement.style) {
  //           window.scrollTo({ top: 0, behavior: 'smooth' });
  //         } else {
  //           window.scrollTo(0, 0);
  //         }
  //       }
  //     }, 300);
  //   };

  //   scrollToTargetPosition();
  // }, [pathname]);

  return (
    <>
      <ViewPage />
      {children}
      {isFailedModalOpen && (
        <FailedModal
          isOpen={isFailedModalOpen}
          onClose={() => setIsFailedModalOpen(false)}
          message={query?.reason || t('payment_failed')}
          showButton={true}
        />
      )}
    </>
  );
};

export default GlobalConfig;
